<script lang="ts" setup>
useHead({
  bodyAttrs: {
    class:
      'font-sans subpixel-antialiased text-neutral-100 bg-inj-black dark:bg-inj-black text-base'
  }
})
</script>

<template>
  <UApp>
    <NuxtLayout>
      <NuxtPage
        :transition="{
          name: 'fade',
          mode: 'out-in'
        }"
      />
    </NuxtLayout>
  </UApp>
</template>
